const CID_PARAM = 'cid';
const STORAGE_KEY = 'vlt_cid';
const CID_MAX_LENGTH = 128;
const CID_PATTERN = /^[A-Za-z0-9_.:-]+$/;

function getStorage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function normalizeCid(value: string | null | undefined): string | null {
  const normalized = value?.trim();
  if (!normalized) return null;
  const truncated =
    normalized.length > CID_MAX_LENGTH ? normalized.slice(0, CID_MAX_LENGTH) : normalized;
  return CID_PATTERN.test(truncated) ? truncated : null;
}

function readQueryCid(): string | null {
  try {
    return normalizeCid(new URL(window.location.href).searchParams.get(CID_PARAM));
  } catch {
    return null;
  }
}

export function readCid(): string | null {
  const storage = getStorage();
  const queryCid = readQueryCid();
  if (queryCid) {
    try {
      storage?.setItem(STORAGE_KEY, queryCid);
    } catch {
      // cid is optional; continue without persistence if storage is blocked.
    }
    return queryCid;
  }

  try {
    return normalizeCid(storage?.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}
